import { Sailboat } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const SailboatIcon = createLucideIcon(Sailboat);
